import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";

export const kymw0901Handlers = [
  http.post(PlessService.SERVICE.KYMW09getChangeItemList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(KYMW09getChangeItemList);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
]

const KYMW09getChangeItemList = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "CommonItem": {
        "CommonChangeItemList": [
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "0",
            "ChangeItemNum": 36,
            "ChangeItemIndex": 0,
            "ChangeItemName": "商品説明",
            "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。",
            "ContentAfterChange": ""
          },
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "0",
            "ChangeItemNum": 37,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー",
            "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
            "ContentAfterChange": ""
          },
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 38,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー誌面掲載",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
          }
        ],
        "PCode": "P2545496"
      },
      "CoopItem": [
        {
          "CoopChangeItemList": [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
          'CoopCode': "142",
          'PlanCoopName': "い",
          'AliasCoopName': "いばらき",
        },
        {
          "CoopChangeItemList": [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
          'CoopCode': "163",
          'PlanCoopName': "と",
          'AliasCoopName': "とちぎ",
        },
      ],
      "ItemCodeItem": [
        {
          'ItemCode': '0001091',
          "ItemCodeChangeItemList": [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
        },
        {
          'ItemCode': '0001082',
          "ItemCodeChangeItemList": [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
        },
        {
          'ItemCode': '0001775',
          "ItemCodeChangeItemList": [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
        },
        {
          'ItemCode': '0001783',
          "ItemCodeChangeItemList": [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
        },
        {
          'ItemCode': '0000302',
          "ItemCodeChangeItemList": [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
        },
        {
          'ItemCode': '0001082',
          "ItemCodeChangeItemList": [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
        },
        {
          'ItemCode': '0000779',
          "ItemCodeChangeItemList": [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "0",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
        },
      ],
      "NextGuide": [
        {
          'CoopCode': "142",
          'MediumType': "001",
          "NextGuideChangeItemList": [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "次回案内",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。次回案内",
              "ContentAfterChange": "次回案内１"
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー次回案内",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください次回案内",
              "ContentAfterChange": "キャッチコピー次回案内２"
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載次回案内",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
        },
        {
          'CoopCode': "163",
          'MediumType': "001",
          "NextGuideChangeItemList": [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。次回案内2",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
        },
      ],
      "LotteryPromotion": {
        'LotteryPromotionChangeItemList': [
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 36,
            "ChangeItemIndex": 0,
            "ChangeItemName": "商品説明",
            "ContentBeforeChange": "",
            "ContentAfterChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。抽選"
          },
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 37,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー",
            "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
            "ContentAfterChange": ""
          },
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 38,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー誌面掲載",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
          }
        ]
      },
      "CouponPromotion": {
        'CouponPromotionChangeItemList': [
          {
            "KeyCode": "0000001",
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 36,
            "ChangeItemIndex": 0,
            "ChangeItemName": "追加フラグ_4490592_061",
            "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。クーポン",
            "ContentAfterChange": ""
          },
          {
            "KeyCode": "0000001",
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 36,
            "ChangeItemIndex": 0,
            "ChangeItemName": "商品説明クーポン",
            "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。クーポン",
            "ContentAfterChange": ""
          },
          {
            "KeyCode": "0000002",
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 37,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー",
            "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
            "ContentAfterChange": ""
          },
          {
            "KeyCode": "0000003",
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 38,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー誌面掲載",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
          }
        ]
      },
      "CouponApplicablePrice": [
        {
          'CoopCode': '142',
          'CouponApplicablePriceChangeItemList': [
            {
              "KeyCode": "0000001",
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明クーポンアプリ",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。クーポンアプリ",
              "ContentAfterChange": ""
            },
            {
              "KeyCode": "0000002",
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "KeyCode": "0000003",
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ]
        },
        {
          'CoopCode': '163',
          'CouponApplicablePriceChangeItemList': [
            {
              "KeyCode": "0000001",
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明クーポンアプリ２",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。クーポンアプリ２",
              "ContentAfterChange": ""
            },
            {
              "KeyCode": "0000002",
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "KeyCode": "0000003",
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ]
        },
      ],
      "PointExchangeBase": {
        'ItemCode': '1234567',
        'PointPromotionChangeItemList': [
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 36,
            "ChangeItemIndex": 0,
            "ChangeItemName": "商品説明ポイント",
            "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。ポイントプロモ",
            "ContentAfterChange": ""
          },
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 37,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー",
            "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
            "ContentAfterChange": ""
          },
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 38,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー誌面掲載",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
          }
        ]
      },
      "PointExchangeCoop": [
        {
          'CoopCode': '142',
          'ItemCode': '1234567',
          'CoopPointRateChangeItemList': [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明ポイント率",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。ポイント率",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ]
        },
        {
          'CoopCode': '163',
          'ItemCode': '1234567',
          'CoopPointRateChangeItemList': [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。ポイント率２",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ]
        },
      ],
      "PlanGoodsEC": {
        'PlanGoodsECChangeItemList': [
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 36,
            "ChangeItemIndex": 0,
            "ChangeItemName": "商品説明EC",
            "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。EC",
            "ContentAfterChange": ""
          },
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 37,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー",
            "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
            "ContentAfterChange": ""
          },
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 38,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー誌面掲載",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
          }
        ]
      },
      "PlanGoodsCoopECStock": [
        {
          'CoopCode': '142',
          'PlanGoodsCoopECStockChangeItemList': [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明ECストック１",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。EC在庫",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ]
        },
        {
          'CoopCode': '163',
          'PlanGoodsCoopECStockChangeItemList': [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。EC在庫２",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ]
        },
      ],
      "PlanGoodsNvalPromotion": [
        {
          "NvalDetailId": "00000001",
          "MediumType": "061",
          "ItemCode": "4490592",
          "PlanGoodsNvalPromotionChangeItemList": [
            {			
            "ChangeItemNum": 999,
            "ChangeItemIndex": 99,
            "ChangeItemName": "プロモ設定を追加_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "0",   
            "ContentBeforeChange": "", 
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 1,
            "ChangeItemIndex": 0,
            "ChangeItemName": "アイテムコード_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "4490592"
            },
            {			
            "ChangeItemNum": 2,
            "ChangeItemIndex": 0,
            "ChangeItemName": "媒体区分_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "061"
            },
            {			
            "ChangeItemNum": 3,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価注文番号割当コード_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "996"
            },
            {			
            "ChangeItemNum": 5,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価詳細区分_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "01"
            },
            {			
            "ChangeItemNum": 6,
            "ChangeItemIndex": 0,
            "ChangeItemName": "商品企画担当区分_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "02"
            },
            {			
            "ChangeItemNum": 7,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価専用商品名_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "テストネーム０１"
            },
            {			
            "ChangeItemNum": 8,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価専用商品名(カナ)_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "ﾃｽﾄﾈｰﾑ01"
            },
            {			
            "ChangeItemNum": 9,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価専用規格名_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "１００ｇ"
            },
            {			
            "ChangeItemNum": 10,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価専用規格名(カナ)_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "100g"
            },
            {			
            "ChangeItemNum": 11,
            "ChangeItemIndex": 0,
            "ChangeItemName": "値引区分_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "0"
            },
            {			
            "ChangeItemNum": 14,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価用値引後供給単価_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "198"
            },
            {			
            "ChangeItemNum": 15,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県1(いばらき)_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "1"
            },
            {			
            "ChangeItemNum": 16,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県2(とちぎ）_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "1"
            },
            {			
            "ChangeItemNum": 17,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県3(ぐんま）_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "1"
            },
            {			
            "ChangeItemNum": 18,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県4(ちば）_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "1"
            },
            {			
            "ChangeItemNum": 19,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県5(さいたま）_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "1"
            },
            {			
            "ChangeItemNum": 20,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県6(とうきょう）_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "1"
            },
            {			
            "ChangeItemNum": 21,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県7(ながの）_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "1"
            },
            {			
            "ChangeItemNum": 22,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県8(にいがた）_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "1"
            },
            {			
            "ChangeItemNum": 23,
            "ChangeItemIndex": 0,
            "ChangeItemName": "備考_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "1"
            },
            {			
            "ChangeItemNum": 23,
            "ChangeItemIndex": 0,
            "ChangeItemName": "供給単価_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "",
            "ContentAfterChange": "1"
            },
            {			
            "ChangeItemNum": 24,
            "ChangeItemIndex": 0,
            "ChangeItemName": "追加フラグ_4490592_061",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "0",
            "ContentAfterChange": "1"
            }
          ]
        },
        {
          "NvalDetailId": "00000002",
          "MediumType": "062",
          "ItemCode": "9999999",
          "PlanGoodsNvalPromotionChangeItemList": [
            {			
            "ChangeItemNum": 21,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県7(ながの）_9999999_062",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "0",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
            },
            {			
            "ChangeItemNum": 22,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県8(にいがた）_9999999_062",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "0", 
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
            },
            {			
            "ChangeItemNum": 23,
            "ChangeItemIndex": 0,
            "ChangeItemName": "備考_9999999_062",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "0", 
            "ContentBeforeChange": "備考１１",
            "ContentAfterChange": "備考９９"
            }
          ]
        },
        {
          "NvalDetailId": "0000003",
          "MediumType": "063",
          "ItemCode": "2222222",
          "PlanGoodsNvalPromotionChangeItemList": [
            {			
            "ChangeItemNum": 999,
            "ChangeItemIndex": 99,
            "ChangeItemName": "プロモ設定を削除_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "0",
            "ContentBeforeChange": "",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 1,
            "ChangeItemIndex": 0,
            "ChangeItemName": "アイテムコード_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "4490592",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 2,
            "ChangeItemIndex": 0,
            "ChangeItemName": "媒体区分_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "063",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 3,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価注文番号割当コード_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "996",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 5,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価詳細区分_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "01",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 6,
            "ChangeItemIndex": 0,
            "ChangeItemName": "商品企画担当区分_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "02",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 7,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価専用商品名_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "テストネーム０１",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 8,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価専用商品名(カナ)_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "ﾃｽﾄﾈｰﾑ01",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 9,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価専用規格名_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "１００ｇ",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 10,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価専用規格名(カナ)_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "100g",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 11,
            "ChangeItemIndex": 0,
            "ChangeItemName": "値引区分_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "0",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 14,
            "ChangeItemIndex": 0,
            "ChangeItemName": "1物N価用値引後供給単価_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "198",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 15,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県1(いばらき)_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
            },
            {			
            "ChangeItemNum": 16,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県2(とちぎ）_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
            },
            {			
            "ChangeItemNum": 17,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県3(ぐんま）_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
            },
            {			
            "ChangeItemNum": 18,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県4(ちば）_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
            },
            {			
            "ChangeItemNum": 19,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県5(さいたま）_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
            },
            {			
            "ChangeItemNum": 20,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県6(とうきょう）_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
            },
            {			
            "ChangeItemNum": 21,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県7(ながの）_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
            },
            {			
            "ChangeItemNum": 22,
            "ChangeItemIndex": 0,
            "ChangeItemName": "利用都県8(にいがた）_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
            },
            {			
            "ChangeItemNum": 23,
            "ChangeItemIndex": 0,
            "ChangeItemName": "備考_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "1",
            "ContentAfterChange": ""
            },
            {			
            "ChangeItemNum": 24,
            "ChangeItemIndex": 0,
            "ChangeItemName": "削除フラグ_2222222_063",		
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
            }
          ]
        },
      ],
      "PlanGoodsPreOrder": {
        'PreOredeDetailId': "0",
        'PlanGoodsPreOrderChangeItemList': [
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "0",
            "ChangeItemNum": 36,
            "ChangeItemIndex": 0,
            "ChangeItemName": "商品説明予約基本",
            "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。予約基本",
            "ContentAfterChange": ""
          },
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "0",
            "ChangeItemNum": 37,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー",
            "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
            "ContentAfterChange": ""
          },
          {
            "SkewerSelect": "0",
            "SkewerSelectLock": "1",
            "ChangeItemNum": 38,
            "ChangeItemIndex": 0,
            "ChangeItemName": "キャッチコピー誌面掲載",
            "ContentBeforeChange": "1",
            "ContentAfterChange": "0"
          }
        ]
      },
      "PlanGoodsPreOrderCoop": [
        {
          'PreOredeDetailId': '100001',
          'PlanGoodsPreOrderCoopChangeItemList': [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明予約詳細",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。予約詳細",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
        },
        {
          'PreOredeDetailId': '100002',
          'PlanGoodsPreOrderCoopChangeItemList': [
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 36,
              "ChangeItemIndex": 0,
              "ChangeItemName": "商品説明",
              "ContentBeforeChange": "果皮はまだ青いものが多い時期。爽やかな酸味ほのかな甘み。予約詳細2",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 37,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー",
              "ContentBeforeChange": "甘酸っぱくみずみずしい食感をおたのしみください",
              "ContentAfterChange": ""
            },
            {
              "SkewerSelect": "0",
              "SkewerSelectLock": "1",
              "ChangeItemNum": 38,
              "ChangeItemIndex": 0,
              "ChangeItemName": "キャッチコピー誌面掲載",
              "ContentBeforeChange": "1",
              "ContentAfterChange": "0"
            }
          ],
        }
      ]
    }
  }
}
